import React from 'react';

const DisputesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7542 2C13.7542 1.44772 13.3065 1 12.7542 1H2C1.44772 1 1 1.44772 1 2V12.6353C1 13.475 1.97241 13.9408 2.62675 13.4145L4.706 11.7421H10.7894C12.4201 11.7421 13.7542 10.4008 13.7542 8.76131V2Z"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M7.0835 11.7421V13.9778C7.0835 15.6172 8.41766 16.9586 10.0483 16.9586H14.3417L16.5936 18.7698C16.9796 19.0803 17.5428 19.0174 17.8516 18.6293C17.9785 18.4697 18.0477 18.2715 18.0477 18.0672V8.91595C18.0477 8.41898 17.647 8.01611 17.1527 8.01611H12.8593V8.01611"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path d="M7.71239 3.69971V6.66655" stroke="#555B67" strokeWidth="2" />
    <path d="M7.71239 7.54577V8.85156" stroke="#555B67" strokeWidth="2" />
  </svg>
);

export default DisputesIcon;
